import {
  DELETE_ITEM,
  DELETE_ITEM_FAILURE,
  DELETE_ITEM_PENDING,
  DELETE_ITEM_SUCCESS,
  GET_ITEMS,
  GET_ITEMS_FAILURE,
  GET_ITEMS_PENDING,
  GET_ITEMS_SUCCESS,
  ITEMS_CLOSE_ADD_MODAL,
  ITEMS_CLOSE_EDIT_MODAL,
  ITEMS_CLOSE_VIEW_MODAL,
  ITEMS_EDIT_MODAL_OPEN_AND_FETCH,
  ITEMS_MODAL_SET_ITEM,
  ITEMS_OPEN_ADD_MODAL,
  ITEMS_VIEW_MODAL_OPEN_AND_FETCH,
  ITEM_EDIT,
  ITEM_EDIT_FAILURE,
  ITEM_EDIT_PENDING,
  ITEM_EDIT_SUCCESS,
  ITEM_SAVE,
  ITEM_SAVE_FAILURE,
  ITEM_SAVE_SUCCESS,
} from "./constants";
const itemActions = {
  getItems: (payload) => {
    return {
      type: GET_ITEMS,
      payload,
    };
  },
  getItemsPending: (payload) => {
    return {
      type: GET_ITEMS_PENDING,
      payload,
    };
  },
  getItemsSuccess: (payload) => {
    return {
      type: GET_ITEMS_SUCCESS,
      payload,
    };
  },
  getItemsFailure: (payload) => {
    return {
      type: GET_ITEMS_FAILURE,
      payload,
    };
  },
  openItemsAddModal: (payload) => {
    return {
      type: ITEMS_OPEN_ADD_MODAL,
      payload,
    };
  },
  closeItemsAddModal: (payload) => {
    return {
      type: ITEMS_CLOSE_ADD_MODAL,
      payload,
    };
  },
  itemsViewModalStartFetching: (payload) => {
    return {
      type: ITEMS_VIEW_MODAL_OPEN_AND_FETCH,
      payload,
    };
  },
  itemsModalSetItem: (payload) => {
    return {
      type: ITEMS_MODAL_SET_ITEM,
      payload,
    };
  },
  closeItemsViewModal: (payload) => {
    return {
      type: ITEMS_CLOSE_VIEW_MODAL,
      payload,
    };
  },
  closeItemsEditModal: (payload) => {
    return {
      type: ITEMS_CLOSE_EDIT_MODAL,
      payload,
    };
  },
  itemsEditModalStartFetching: (payload) => {
    return {
      type: ITEMS_EDIT_MODAL_OPEN_AND_FETCH,
      payload,
    };
  },
  // Save Items

  saveItem: (payload) => {
    return {
      type: ITEM_SAVE,
      payload,
    };
  },
  saveItemPending: (payload) => {
    return {
      type: ITEM_EDIT_PENDING,
      payload,
    };
  },
  saveItemSuccess: (payload) => {
    return {
      type: ITEM_SAVE_SUCCESS,
      payload,
    };
  },
  saveItemFailure: (payload) => {
    return {
      type: ITEM_SAVE_FAILURE,
      payload,
    };
  },

  // Edit Items

  editItem: (payload) => {
    return {
      type: ITEM_EDIT,
      payload,
    };
  },
  editItemPending: (payload) => {
    return {
      type: ITEM_EDIT_PENDING,
      payload,
    };
  },
  editItemSuccess: (payload) => {
    return {
      type: ITEM_EDIT_SUCCESS,
      payload,
    };
  },
  editItemFailure: (payload) => {
    return {
      type: ITEM_EDIT_FAILURE,
      payload,
    };
  },

  //For delete Item
  deleteItem: (payload) => {
    return {
      type: DELETE_ITEM,
      payload,
    };
  },
  deleteItemPending: (payload) => {
    return {
      type: DELETE_ITEM_PENDING,
      payload,
    };
  },
  deleteItemSuccess: (payload) => {
    return {
      type: DELETE_ITEM_SUCCESS,
      payload,
    };
  },
  deleteItemFailure: (payload) => {
    return {
      type: DELETE_ITEM_FAILURE,
      payload,
    };
  },
};
export default itemActions;
